import React from 'react';

const AboutUs = () => {
  const teamMembers = [
    {
      name: "Niamh Shea",
      role: "Co-founder & Executive",
      image: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=2070"
    },
    {
      name: "Orla Dwyer",
      role: "Orla Dwyer",
      image: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=2070"
    },
    {
      name: "Danien James",
      role: "Co-founder, Chairman",
      image: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=2070"
    },
    {
      name: "Dara Frazier",
      role: "Chief Strategy Officer",
      image: "https://images.pexels.com/photos/834863/pexels-photo-834863.jpeg?auto=compress&cs=tinysrgb&w=2070"
    },
    {
      name: "Andrea Jerina",
      role: "HR Officer",
      image: "https://images.pexels.com/photos/1587009/pexels-photo-1587009.jpeg?auto=compress&cs=tinysrgb&w=2070"
    },
    {
      name: "Melvin Davis",
      role: "Lead Developer",
      image: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=2070"
    }
  ];

  return (
    <div className="w-full bg-white">
      {/* Header Banner */}
      <div className="relative w-full h-40">
        <img 
          src="https://images.pexels.com/photos/4033112/pexels-photo-4033112.jpeg?auto=compress&cs=tinysrgb&w=2070" 
          alt="Fresh vegetables banner"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl font-bold">About Us</h1>
        </div>
      </div>

      {/* Welcome Section */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div>
            <h2 className="text-3xl font-bold mb-6">Welcome to our Ecomify shop</h2>
            <p className="text-gray-600 mb-6">
              Holisticly seize parallel metrics and functional ROI. Seamlessly revolutionize error-free internal or organic sources before effective scenarios. Progressively incentivize state of the art applications for efficient intellectual capital. Credibly leverage existing distinctive mindshare through cutting-edge schemas.
            </p>
            <p className="text-gray-600">
              Proactively procrastinate team building paradigms coordinate client-centric total transparent internal. Dynamically embrace diverse customer service and installed base paradigms.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mt-12">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-4xl font-bold mb-2">8K</h3>
                <p className="font-semibold mb-2">Lovely Customer</p>
                <p className="text-gray-600 text-sm">
                  Competently productize virtual models without performance.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-4xl font-bold mb-2">10K</h3>
                <p className="font-semibold mb-2">Listed Products</p>
                <p className="text-gray-600 text-sm">
                  Dynamically morph team driven partnerships after vertical.
                </p>
              </div>
            </div>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <img 
              src="https://images.pexels.com/photos/2255935/pexels-photo-2255935.jpeg?auto=compress&cs=tinysrgb&w=2070" 
              alt="Store interior"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="grid gap-4">
              <img 
                src="https://images.pexels.com/photos/1656663/pexels-photo-1656663.jpeg?auto=compress&cs=tinysrgb&w=2070" 
                alt="Fresh produce"
                className="w-full h-full object-cover rounded-lg"
              />
              <img 
                src="https://images.pexels.com/photos/2751755/pexels-photo-2751755.jpeg?auto=compress&cs=tinysrgb&w=2070" 
                alt="Vegetables display"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Full Width Image */}
      <div className="w-full h-48 relative my-12">
        <img 
          src="https://images.pexels.com/photos/1093837/pexels-photo-1093837.jpeg?auto=compress&cs=tinysrgb&w=2070" 
          alt="Fresh vegetables display"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Team Section */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold mb-6">Our Team</h2>
        <p className="text-gray-600 mb-12">
          We're impartial and independent, and every day we create distinctive, world-class reintermediate backend supply programmes.
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center">
              <img 
                src={member.image}
                alt={member.name}
                className="w-full aspect-square object-cover rounded-lg mb-4"
              />
              <h3 className="font-semibold">{member.name}</h3>
              <p className="text-gray-600 text-sm">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;